<!--
 * @Description  : 鼎信数智文库 首页
 * @Author       : 王帅
 * @Date         : 2024-09-25 09:58:29
 * @LastEditors  : zhanglei
 * @LastEditTime : 2025-07-18 10:14:06
 * @FilePath     : \ngs_platform_manage_admin\src\views\library-server\library-index.vue
-->
<template>
	<div class="library-layout">
		<header class="library-header">
			<div class="main-container header-content">
				<div class="header-logo"
					 @click="goHome">
					<img id="svg-image"
						 :src="homeLogo"
						 alt="" />
				</div>
				<div class="header-title">{{ pageInfo.title }}</div>
				<div class="header-search">
					<el-input class="search-input"
							  placeholder="请输入标题进行搜索"
							  clearable
							  v-model="queryObj.title">
						<!-- 前缀 -->
						<template #prepend
								  v-if="$route.name === 'libraryHome' && pageInfo.showType == 1">
							<el-select class="search-select"
									   v-model="queryObj.typeId"
									   clearable
									   @change="getPageData"
									   placeholder="选择分类">
								<el-option v-for="item in selectTypes"
										   :key="item.value"
										   :label="item.sname"
										   :value="item.id"> </el-option>
							</el-select>
						</template>
						<!-- 后缀 -->
						<template #append>
							<el-button type="primary"
									   @click="doSearch">搜索</el-button>
						</template>
					</el-input>
					<el-popover placement="bottom-end"
								trigger="manual"
								v-model="showMoreFilter">
						<!-- 高级搜索筛选框 -->
						<div class="filter-more">
							<div class="filter-header">
								<span>筛选条件</span>
								<span class="close-btn"
									  @click="showMoreFilter = false">×</span>
							</div>
							<div class="filter-content">
								<el-form label-width="110px"
										 ref="searchForm"
										 :model="queryObj">
									<el-row noSpace>
										<el-col :span="12">
											<el-form-item label="检索范围"
														  prop="searchType">
												<el-radio-group v-model="queryObj.searchType">
													<el-radio label="0">标题</el-radio>
													<el-radio label="1">正文</el-radio>
													<el-radio label="2">标题+正文</el-radio>
												</el-radio-group>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="检索方式"
														  prop="fuzzySearch">
												<el-radio-group v-model="queryObj.fuzzySearch">
													<el-radio label="0">精确查找</el-radio>
													<el-radio label="1">模糊查找</el-radio>
												</el-radio-group>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row noSpace>
										<el-col :span="12">
											<el-form-item label="颁布机关"
														  prop="issuesUnit">
												<el-input v-model="queryObj.issuesUnit"
														  clearable
														  placeholder="请输入"> </el-input>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="文号"
														  prop="referNo">
												<el-input v-model="queryObj.referNo"
														  clearable
														  placeholder="请输入"> </el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row noSpace>
										<el-col :span="12">
											<el-form-item label="时效性"
														  prop="efficient">
												<el-select class="search-select"
														   v-model="queryObj.efficient"
														   clearable>
													<el-option v-for="item in projectDict.zsksxx"
															   :key="item.value"
															   :label="item.sname"
															   :value="item.value">
													</el-option>
												</el-select>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="法律效力位阶"
														  prop="lawRank">
												<el-select class="search-select"
														   v-model="queryObj.lawRank"
														   clearable>
													<el-option v-for="item in projectDict.flxlwj"
															   :key="item.value"
															   :label="item.sname"
															   :value="item.value">
													</el-option>
												</el-select>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row noSpace>
										<el-col :span="12">
											<el-form-item label="施行日期">
												<el-date-picker @change="changeTime($event, 'applyDate')"
																v-model="queryObj.applyDate"
																type="daterange"
																start-placeholder="开始日期"
																end-placeholder="结束日期"
																range-separator="-"
																value-format="yyyy-MM-dd"></el-date-picker>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="公布日期">
												<el-date-picker @change="changeTime($event, 'releaseDate')"
																v-model="queryObj.releaseDate"
																type="daterange"
																start-placeholder="开始日期"
																end-placeholder="结束日期"
																range-separator="-"
																value-format="yyyy-MM-dd"></el-date-picker>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row noSpace>
										<el-col :span="24"
												class="text-center">
											<span class="footer-btn btn-reset"
												  @click="doReset">重置</span>
											<span class="footer-btn"
												  @click="doSearch">查询</span>
										</el-col>
									</el-row>
								</el-form>
							</div>
						</div>
						<template #reference>
							<el-button @click="showMoreFilter = true">高级搜索</el-button>
						</template>
					</el-popover>
				</div>
			</div>
		</header>
		<nav class="library-breadcrumb main-container"
			 :class="{ 'no-content-tabs': $route.name == 'libraryHome' && pageInfo.showType != 1 }">
			<!-- 如果不是在首页 -->
			<template v-if="$route.name !== 'libraryHome'">
				当前位置：
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item v-for="(item, index) in activeBreadList"
										:key="'breadcrumb' + index"
										:to="item.to">
						{{ item.label }}
					</el-breadcrumb-item>
				</el-breadcrumb>
			</template>
			<!-- 首页且是平铺的情况 -->
			<template v-else>
				<el-tabs separator
						 v-model="queryObj.typeId"
						 @tab-click="(tabs) => getPageData(tabs.name)"
						 v-if="pageInfo.showType == 0">
					<el-tab-pane v-for="(item, index) in selectTypes"
								 :name="item.id"
								 :key="item.id + index + 'tab'">
						<template #label>
							<div class="slot-title-box">
								<span class="slot-title">{{ item.sname }}</span>
								<span class="slot-icon"></span>
							</div>
						</template>
					</el-tab-pane>
				</el-tabs>
			</template>
		</nav>

		<main class="library-main">
			<router-view />
		</main>

		<footer class="library-footer">
			<div class="main-container footer-container">
				<div class="footer-left-history">
					<span>系统访问次数：<i>{{ pageFooter.accessTimes }}</i></span>
					<span>下载次数：<i>{{ pageFooter.downloadTimes }}</i></span>
				</div>
				<div class="footer-right-copyright">
					<template v-if="alias === 'xhwk'">
						<span>版权所有：鼎信数智技术集团股份有限公司</span>
						<span @click="toLink">皖ICP备18011150号-7</span>
					</template>
					<template v-else>
						<span>版权所有：安徽本末数据科技有限公司</span>
						<span @click="toLink">皖ICP备18011150号-6</span>
					</template>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import * as Api from '@/api/modules/library-server/index.js'
import { bmStorage } from '../../utils/tools'
export default {
	name: '',
	data() {
		return {
			// 搜索对象
			queryObj: {
				alias: '', // 招采文库 暂时写死
				typeId: '', // 类型ID(下拉列表ID)
				id: '', // 分类ID(卡片ID)
				title: '', // 标题
				searchType: '0', //检索范围 0-标题，1-正文，2-标题+正文
				fuzzySearch: '1', //检索方式 1-模糊，0-精确
				issuesUnit: '', // 颁布机关
				referNo: '', // 文号
				efficient: '', // 时效性
				lawRank: '', // 法律效力位阶
				applyDate: [], // 施行日期数组
				applyStart: '', // 施行日期开始
				applyEnd: '', // 施行日期结束
				releaseDate: [], // 公示日期数组
				releaseStart: '', // 公示日期开始
				releaseEnd: '' // 公示日期结束
			},
			showcenter: false, //首页标识
			// 下拉列表
			selectTypes: [],
			// 面包屑数组
			navList: [
				{
					label: '首页',
					to: {
						name: 'libraryHome'
					}
				}
			],
			// 卡片列表
			showTypes: [],
			// 页面集合对象
			pageInfo: {
				title: '',
				homeLogo: '',
				// 最大显示条数
				showNum: 5,
				// 分类展示形式
				showType: 0 // 0 平铺 1 下拉
			},
			// 底部记录
			pageFooter: {
				accessTimes: 0, // 访问次数
				downloadTimes: 0 // 下载次数
			},
			// 高级搜索
			showMoreFilter: false,
			// 详情页储存
			detailInfo: {},
			projectDict: {
				flxlwj: [], //
				zsksxx: '' // 政策时效性
			},
			homeLogo: ''
		}
	},
	methods: {
		// #region 页面接口管理
		// 浏览记录保存
		saveRead() {
			let params = {
				alias: this.alias, // 招采文库 暂时写死
				fileId: '',
				type: 0 // 1 下载 ，0阅读
			}
			Api.saveRead(params).then((res) => {})
		},

		// 获取知识库字典
		getZjkDictsBySysCode() {
			Api.getZjkDictsBySysCode({}).then((res) => {
				this.projectDict = res.data
			})
		},

		// 首页列表等接口加载
		getPageData(typeId = '', isFirst = false) {
			// 控制首页显示
			this.showcenter = false
			let params = {
				alias: this.alias, // 招采文库 暂时写死
				typeId // 下拉的类型ID 默认传空
			}

			if (typeId == '' && !isFirst) {
				return
			}
			if (typeId == '1') {
				this.showcenter = true
				return
			}

			// 如果首次页面加载 重置参数
			if (isFirst) {
				this.resetParams()
			}

			Api.zcHomePage(params).then((res) => {
				// 赋值底部 浏览记录信息
				this.pageFooter.accessTimes = res.data.accessTimes || 0
				this.pageFooter.downloadTimes = res.data.downloadTimes || 0

				// 下拉列表
				this.selectTypes = res.data.selectTypes || []

				// 默认第一个
				if (res.data.selectTypes?.length > 0 && typeId === '') {
					this.queryObj.typeId = res.data.selectTypes[0].id || ''
				}

				// 列表
				Object.keys(this.pageInfo).map((x) => {
					if (res.data[x] != undefined && res.data[x] != null) {
						this.pageInfo[x] = res.data[x]
					}
				})
				// 缓存页面标题 图标等
				bmStorage.sessionStorage.set(
					'baseInfo',
					JSON.stringify(this.pageInfo)
				)

				this.showNum = res.data.showNum || 5
				this.showType = res.data.showType || 1
				if (this.pageInfo.showType == 0) {
					this.selectTypes.splice(0, 0, {
						id: '1', //
						sname: '首页'
					})
				}
				this.showTypes = res.data.showTypes || []
			})
		},
		// #endregion

		// #region 页面功能按钮
		// 点击图标返回首页
		goHome() {
			this.pageInfo.showType = 0
			bmStorage.sessionStorage.remove('baseInfo')
			this.$router.push({
				path: '/library-server/home',
				query: {
					alias: this.alias
				}
			})
		},

		// 高级搜索的 重置
		doReset() {
			this.$refs.searchForm.resetFields()
			this.resetParams()
		},

		resetParams() {
			this.queryObj = {
				alias: this.alias, // 招采文库 暂时写死
				typeId: '', // 类型ID(下拉列表ID)
				id: '', // 分类ID(卡片ID)
				title: '', // 标题
				searchType: '0', //检索范围 0-标题，1-正文，2-标题+正文
				fuzzySearch: '1', //检索方式 1-模糊，0-精确
				issuesUnit: '', // 颁布机关
				referNo: '', // 文号
				efficient: '', // 时效性
				lawRank: '', // 法律效力位阶
				applyDate: [], // 施行日期数组
				applyStart: '', // 施行日期开始
				applyEnd: '', // 施行日期结束
				releaseDate: [], // 公示日期数组
				releaseStart: '', // 公示日期开始
				releaseEnd: '' // 公示日期结束
			}
		},

		// 执行查询
		doSearch(type) {
			this.showMoreFilter = false
			// 找到 列表页
			let child_list = this.$children.find(
				(item) => item.$options.name === 'libraryList'
			)

			// 如果不在列表页  先切换到列表页
			if (!child_list) {
				// 重置id
				let params = {
					sname: '',
					id: ''
				}
				bmStorage.sessionStorage.set(
					'libraryListPage',
					JSON.stringify(params)
				)

				this.$router.push({
					name: 'libraryList'
				})
				return
			}

			// 找到 列表页
			child_list = this.$children.find(
				(item) => item.$options.name === 'libraryList'
			)
			child_list.doSearch()
		},

		// #endregion
		// 切换导航条（面包屑）
		changeRoute(item) {
			// console.log('😍 ~ changeRoute ~ item:', item)
		},

		// 日期处理
		changeTime(arr, type) {
			switch (type) {
				case 'applyDate':
					this.queryObj.applyStart = !!arr ? arr[0] : ''
					this.queryObj.applyEnd = !!arr ? arr[1] : ''
					break
				case 'releaseDate':
					this.queryObj.releaseStart = !!arr ? arr[0] : ''
					this.queryObj.releaseEnd = !!arr ? arr[1] : ''
					break
				default:
			}
		},

		// 关闭AI
		hiddenAi(val) {
			setTimeout(() => {
				let ai_button = document.querySelector(
					'#dify-chatbot-bubble-button'
				)
				let ai_iframe = document.querySelector(
					'#dify-chatbot-bubble-window'
				)
				if (ai_button) {
					ai_button.style.visibility = 'hidden'
				}
				if (ai_iframe) {
					ai_iframe.style.visibility = 'hidden'
				}

				let fastAi_button = document.querySelector(
					'#fastgpt-chatbot-button'
				)
				let fastAi_iframe = document.querySelector(
					'#fastgpt-chatbot-window'
				)
				if (fastAi_button) {
					fastAi_button.style.visibility = 'hidden'
				}
				if (fastAi_iframe) {
					// fastAi_iframe.style.visibility = val.path !== '/login' ? 'visible' : 'hidden'
				}
			}, 2000)
		},

		// 备案号跳转
		toLink() {
			let url = 'https://beian.miit.gov.cn/#/Integrated/index'
			window.open(url, '_blank')
		},
		//  获取svg图片的base64
		async svgUrlToBase64(url) {
			try {
				// 1. 发送HTTP请求获取SVG内容
				const response = await fetch(url)
				if (!response.ok)
					throw new Error(`HTTP error! status: ${response.status}`)

				// 2. 读取为文本
				const svgText = await response.text()

				// 3. 转换为Base64
				const svgBlob = new Blob([svgText], { type: 'image/svg+xml' })
				const reader = new FileReader()

				return new Promise((resolve, reject) => {
					reader.onloadend = () => {
						// 提取Base64部分（去掉"data:image/svg+xml;base64,"前缀）
						const base64 = reader.result.split(',')[1]
						resolve(base64)
					}
					reader.onerror = reject
					reader.readAsDataURL(svgBlob)
				})
			} catch (error) {
				console.error('Error converting SVG to Base64:', error)
				return null
			}
		},

		// 自定义logoUrl获取
		customLogo() {
			let url = this.pageInfo.homeLogo
			let gs = this.pageInfo.homeLogo.split('.')
			if (gs[gs.length - 1] == 'svg') {
				this.svgUrlToBase64(this.pageInfo.homeLogo)
					.then((base64) => {
						if (base64) {
							// 可直接用于<img>标签
							document.getElementById(
								'svg-image'
							).src = `data:image/svg+xml;base64,${base64}`
						}
					})
					.catch(() => {
						return url
					})
				return
			}
			return url
		},

		// 安全读取并解析 sessionStorage 数据
		getParsedSessionStorage(key, defaultValue = {}) {
			try {
				const value = bmStorage.sessionStorage.get(key)
				return value ? JSON.parse(value) : defaultValue
			} catch (e) {
				console.error(`解析 sessionStorage[${key}] 出错`, e)
				return defaultValue
			}
		}
	},
	created() {
		// 存储数据 alias
		if (this.$route.query.alias) {
			bmStorage.sessionStorage.set('alias', this.$route.query.alias)
		}
		// 首页数据(判断在首页加载)
		if (this.$route.name === 'libraryHome' && this.pageInfo.showType == 0) {
			this.queryObj.typeId = '1'
			this.getPageData('1')
		} else {
			// this.queryObj.typeId = ''
			this.getPageData('', true)
		}
		// 如果不在首页 取sessionStorage 里面的baseInfo 赋值标题等基础数据
		if (this.$route.name !== 'libraryHome') {
			let baseInfo = bmStorage.sessionStorage.get('baseInfo')
			if (baseInfo) {
				this.pageInfo = JSON.parse(baseInfo)
			}
		}

		// 进来就 浏览次数 + 1
		this.saveRead()
		this.getZjkDictsBySysCode()
	},
	mounted() {
		// this.hiddenAi()
	},
	computed: {
		// 动态面包屑
		activeBreadList() {
			// 深拷贝原始 navList 数据，避免直接修改原始数据
			let arr = this.$utils.clone(this.navList, true)
			const route = this.$route
			const query = route.query

			// 从 sessionStorage 获取列表页和详情页的缓存信息
			const libraryListPage = this.getParsedSessionStorage(
				'libraryListPage',
				{}
			)
			const libraryDetailPage = this.getParsedSessionStorage(
				'libraryDetailPage',
				{ detailName: query.detailName, detailId: query.detailId }
			)

			// 判断是否存在列表页名称和详情页名称
			const hasLibraryListSname = !!libraryListPage.sname
			const hasLibraryDetailName = !!libraryDetailPage.detailName

			// 提前处理公共部分  如果存在列表页名称，添加到面包屑中
			if (hasLibraryListSname) {
				arr.push({
					label: libraryListPage.sname,
					to: {
						name: 'libraryList',
						query: {
							sname: libraryListPage.sname,
							id: libraryListPage.id
						}
					}
				})
			}

			// 如果当前是详情页且存在详情名称，添加到面包屑中
			if (route.name === 'libraryDetail' && hasLibraryDetailName) {
				arr.push({
					label: libraryDetailPage.detailName,
					to: {
						name: 'libraryDetail',
						query: {
							detailName: libraryDetailPage.detailName,
							detailId: libraryDetailPage.detailId
						}
					}
				})
			}

			// 如果当前是列表页但是不存在列表名称
			if (
				route.name === 'libraryList' &&
				hasLibraryListSname === false &&
				query.parentId &&
				query.parentName
			) {
				arr = [
					{
						label: query.parentName,
						to: {
							name: 'libraryHome',
							query: { sname: query.parentName, id: '1' }
						}
					},
					{
						label: query.sname,
						to: {
							name: 'libraryList',
							query: { sname: query.sname, id: query.id }
						}
					}
				]
			}

			return arr
		},

		// 请求参数的alias
		alias() {
			return (
				this.$route.query.alias ||
				bmStorage.sessionStorage.get('alias') ||
				'xhwk'
			)
		}
	},
	watch: {
		// 监听路由是否在首页
		$route(to, from) {
			console.log(to)

			// this.hiddenAi()
			if (to.name === 'libraryHome') {
				if (this.queryObj.showType == 0) {
					this.queryObj.typeId =
						JSON.parse(
							bmStorage.sessionStorage.get('libraryListPage')
						).parentId || '1'
					this.getPageData('1')
				} else if (
					['libraryDetail', 'libraryList'].includes(from.name)
				) {
					this.pageInfo.showType = 0
					this.queryObj.typeId = '1'
					this.getPageData('1')
				} else {
					this.queryObj.typeId = ''
					this.getPageData('', true)
				}

				// 先保存tab id 进行回显

				// 清空sessionstorage
				bmStorage.sessionStorage.remove('libraryListPage')
				bmStorage.sessionStorage.remove('libraryDetailPage')
			}

			if (to.name === 'libraryList') {
				// 二级tab名称
				this.navList[0].label =
					this.$route.query.parentName || this.navList[0].label
				this.navList[0].to.name = 'libraryHome'
				this.navList[0].to.query = {
					sname: this.$route.query.parentName || '首页',
					id: this.$route.query.parentId | '1'
				}
				// 清空sessionstorage
				bmStorage.sessionStorage.remove('libraryDetailPage')
			}

			// 如果alias 变更
			if (to.query.alias) {
				bmStorage.sessionStorage.set('alias', to.query.alias)
			}
		},

		pageInfo: {
			handler(val) {
				this.homeLogo = this.customLogo()
			},
			deep: true
		}
	}
}
</script>
<style scoped lang="less">
@import url('./library.less');
</style>
